'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryListController = function () {
  function EnquiryListController(authService, enquiryService, loadingService, lookupService, enums, $window) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EnquiryListController);
    if (!authService.validateUser(false, 'Enquiry', enums.PERMISSION_TYPE.View, true)) {
      return;
    }

    this.authService = authService;
    this.enquiryService = enquiryService;
    this.loadingService = loadingService;
    this.lookupService = lookupService;
    this.enums = enums;
    this.$window = $window;

    this.selectOptions = {};
    this.filterParams = {};

    this.initializeEnums();
  }

  (0, _createClass3.default)(EnquiryListController, [{
    key: 'initializeEnums',
    value: function initializeEnums() {
      var ctrl = this;
      var enumList = [{ enumName: 'ENQUIRY_STATE', propName: 'enquiryState', defaultOption: true, defaultOptionText: 'All States' }];

      enumList.map(function (item) {
        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption, item.defaultOptionText);
        ctrl.selectOptions[item.propName] = enumsArray;
      });

      this.reset();
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption, defaultOptionText) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: defaultOptionText || 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'reset',
    value: function reset() {
      var ctrl = this;

      this.filterParams.entityId = this.authService.authData.currentLocation.key;
      this.filterParams.subject = '';
      this.filterParams.contactName = '';
      this.filterParams.ownerName = '';
      this.filterParams.status = null;

      this.pagination = {
        totalItems: 0,
        currentPage: 1,
        pageSize: 10
      };

      this.filterParams.pageCriteria = {
        pageStart: 0,
        itemsToFetch: this.pagination.pageSize,
        sortExpression: 'lastModified',
        ascending: false
      };

      this.notification = {
        type: 'info',
        msg: ''
      };

      this.listEnquiries();
    }
  }, {
    key: 'updatePageIndex',
    value: function updatePageIndex() {
      if (this.pagination.currentPage === 1) {
        this.filterParams.pageCriteria.pageStart = 0;
      } else {
        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      }
    }
  }, {
    key: 'updateSort',
    value: function updateSort(fieldName) {
      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
      } else {
        this.filterParams.pageCriteria.sortExpression = fieldName;
        this.filterParams.pageCriteria.ascending = true;
      }

      this.listEnquiries();
    }
  }, {
    key: 'listEnquiries',
    value: function listEnquiries() {
      var ctrl = this;

      ctrl.updatePageIndex();

      ctrl.loadingService.showLoading('enquiryListing', 'Loading Enquiries ...');

      ctrl.enquiryService.listEnquiries(ctrl.filterParams).then(function (response) {
        ctrl.enquiries = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: 'No data to display'
          };
        } else {
          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' enquiries'
          };
        }
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquiryListing');
      });
    }
  }, {
    key: 'deleteContact',
    value: function deleteContact(contactId) {
      var _this = this;

      var ctrl = this;
      var sure = void 0,
          state = void 0;

      sure = this.$window.confirm('Are you sure you want to delete this Contact ?');

      if (!sure) {
        return;
      }

      this.loadingService.showLoading('contactListing', 'Removing Contact ...');

      ctrl.contactService.updateContactState(this.authService.authData.currentLocation.key, contactId, this.enums.OBJECT_ROW_STATE.Deleted).then(function (response) {
        ctrl.listContacts();
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while updating contact state. " + err.data.messageDetail ? err.data : err.data.messageDetail
        };
      }).finally(function () {
        _this.loadingService.hideLoading('contactListing');
      });
    }
  }]);
  return EnquiryListController;
}();

exports.default = EnquiryListController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryList/enquiryList.controller.js